import * as React from 'react'
import { Link } from 'react-router-dom'

import parse, { domToReact } from 'html-react-parser'

interface Props {
  html: string
}

const HTMLWithMentions = ({ html }: Props) => {
  function parseWithLinks(html: string) {
    const options = {
      replace: ({ name, attribs, children }: any) => {
        if (name === 'a' && attribs.href && attribs.class === 'link_mentioned') {
          return (
            <span onClick={(e) => e.stopPropagation()}>
              <Link to={attribs.href}>{domToReact(children)}</Link>
            </span>
          )
        }
      },
    }

    return parse(html, options)
  }

  return <div>{parseWithLinks(html)}</div>
}

export default HTMLWithMentions
